package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("/flutter/basic")
@Composable
fun BasicPage() {
    BlogLayout(
        PageProperties(
            "Architecture",
            "Explain the deep Flutter architecture, BuildContext, Rendering tree and How to work setState() internal and performance benefits."
        ),
        BlogProperties("Flutter", "Architecture | Element Tree | RenderObject | Render Tree | SetState result new frame set")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Skia (Old)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter achieves high performance by using its own high-performance rendering engine (Skia) and a reactive framework that minimizes the need for JavaScript bridges.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It also compiles to native ARM code, which allows for smooth animations and quick rendering.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Impeller (New)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter 3.10 introduces Impeller in iOS apps by default. Impeller provides a new rendering runtime for Flutter. The Flutter team's believes this solves Flutter's early-onset jank issue. Impeller precompiles a smaller, simpler set of shaders at Engine-build time so they don't compile at runtime.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Flutter architecture",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter architecture and system for those interested: Flutter is a UI toolkit that lets you build native apps for web, desktop, and mobile devices from one codebase.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It uses Dart, a cross-platform language, and Flutter Engine, a portable runtime.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter is made of layers of libraries that depend on each other. No layer can access the lower layer directly, and you can change any part of the framework.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Upper layers",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The Dart-based platform that takes care of app widgets, gestures, animations, illustrations, and materials.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Engine Layer",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is the core layer of the Flutter architecture that contains the rendering engine, which handles graphics and text rendering. It also includes the Skia graphics library, used to draw graphics on the screen.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Built-in service",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Used for the management of plugins, packages, and event loops.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Platform Layer",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is the lowest layer in the Flutter architecture and provides access to the native platform APIs.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It includes plugins and packages that allow Flutter to interact with the device’s hardware and software, such as the camera, location services, and sensors.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "The layers are",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Embedder",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The code that runs on the platform and talks to the OS for services like rendering, input, etc. It is written in the platform’s language, like Java or C++.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Engine",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The core of Flutter that handles input, output, network, and rendering.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It uses an impeller, a graphics library, to draw the UI.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It is written in C/C++, and it connects to the framework with a dart:ui.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Framework",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The framework that helps you build Flutter apps. It is written in Dart and has sub-layers.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Foundation",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The basic classes and services for animation, drawing, gestures, etc.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Widgets",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Widgets are immutable, core building blocks of a Flutter, and describe the configuration or state of the UI.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It is a user interface.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Two main widgets in Flutter can be either stateless or stateful, depending on whether they maintain their state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Widgets are rendered onto a Skia / impeller canvas with support for advanced animations and gesture recognition.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "They represent the configuration for RenderObjects. Flutter is optimized such that it can easily create and destroy widgets without any significant performance implications.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Widgets are lightweight and inexpensive to instantiate, making them suitable for representing the current state or configuration of the app.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }


                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Rendering",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The layer that lays out and paints the widgets on the screen.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Material and Cupertino",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The layers that provide widgets that follow Android and iOS design guidelines.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "Why Is BuildContext Important?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There are many reasons why BuildContext is important.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "From locating widgets in the tree to interacting with RenderObjects, the context makes all of these interactions possible.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It serves as the “bridge” between the widgets and rendering layer and is especially powerful for combining functionality or using information from one tree in another.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "BuildContext: Connecting Widgets",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The BuildContext is a crucial part of the widget tree. It is a reference to the location of a widget within the tree, allowing you to access information about other widgets and theme data. When you build a widget, you pass the BuildContext as a parameter.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You usually use BuildContext to get a reference to the theme or another widget. For example, if you want to show a material dialog, you need a reference to the scaffold. You can get it with Scaffold.of(context), where context is the build context. of() searches up the tree until it finds the nearest scaffold.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = ". of () will start finding the object of the exact type from above of the current context.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "What Is BuildContext?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BuildContext of a widget represents the widget’s location in Flutter’s Widget Tree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                        Widget build(BuildContext context)=> MyAwesomeWidget();
                    """.trimIndent()
                )
            }

            WebImage(src = Resources.Images.WIDGET_BUILDCONTEXT_FLUTTER,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Widget BuildContext")

            SpanText(
                text = "RenderObject",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Every widget in Flutter has a drawing on the screen via a need called RenderObject. This is the one that deals with painting, moving widgets, and hit testing. In short, he is the engineer who draws everything on the screen with a ruler and a leg. Flutter uses a low-level rendering library called the “rendering engine.” RenderObjects are mutable and responsible for rendering the visual elements of the widgets.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They create a tree of render objects, which corresponds to the widget tree. Each widget creates its own RenderObject or inherits one from its parent.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Whenever the configuration of a widget changes, the framework looks at the change and updates the associated RenderObject instead of creating a new one each time.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(top = 0.8.em, bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "RenderObject a widget would extend:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If a widget has zero number of children, it extends LeafRenderObjectWidget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If it has one child, it extends SingleChildRenderObjectWidget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If it has two or more children, it extends MultiChildRenderObjectWidget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "There are two main types of RenderObjects",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Layout",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Rectangular layout, constrained by width and height.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Flexible layout, optimized for scrollable areas.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Coordinate System",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Cartesian (x, y) coordinates, easy to understand.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Sliver-specific coordinates (scroll offset, cross-axis position), more complex.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Use Cases",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Ideal for most layouts, such as grids, lists, and columns.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Suitable for scrollable views with large or lazy-loaded content, like infinite lists.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Rendering Efficiency",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Less efficient for large scrollable areas or lazy-loaded content.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "More efficient for large scrollable areas, as only visible content is rendered.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Hit Testing",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Uses hit testing for interaction based on Cartesian coordinates.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Uses hit testing specific to the sliver layout system.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Examples",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Container, Column, Row, Stack etc.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "CustomScrollView, SliverList, SliverGrid etc.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "RenderBox",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )
                }

                Ul {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "A rectangular area that handles layout, painting, and hit testing.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "RenderSliver",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )
                }

                Ul {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "A more flexible layout approach, mainly used in scrollable areas.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When a widget’s build a method is called, it returns a new widget tree that is then translated into a RenderObject tree. The RenderObject tree is what Flutter actually paints on the screen.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Relationship Between Widgets, BuildContext, and RenderObject",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Widget",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Define Ul components and their configuration",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Widgets are organized in a tree structure. Each widget can create its own RenderObject.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "BuildContext",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Reference to the location of a widget in the tree",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Passed to the build method, allowing access to ancestor widget data and theme information.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "RenderObject",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Handle layout, painting, and hit testing of the UI",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Created by the widget tree, the RenderObject tree is responsible for rendering the actual Ul elements.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "Element Tree",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the middle of Widgets and RenderObjects sits Elements.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter maintains a separate element tree, which is a lightweight representation of the widget tree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It helps manage the relationships between widgets and their corresponding render objects (These act as the glue between the immutable widget layer and the mutable render layer).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Manages the lifecycle and states while keeping a record of the position of the widget in the tree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Each element holds references to both a widget and a render object.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Elements are skilled at comparing two objects, specifically the widget and the render object.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Elements essentially represent the use of a widget to configure a specific location in the tree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The BuildContext passed in every build(BuildContext context) function is actually the corresponding Element wrapped into the BuildContext interface and that’s why it’s different for every single widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "As the configuration of a widget changes (for example, a user calls setState which triggers a rebuild), the element looks at the incoming changes and tells the associated render object, Hey! The user requested a change, it is time for you to update.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Element is an instantiation of a Widget at a particular location in the tree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The BuildContext passed in every build(BuildContext context) function is actually the corresponding Element wrapped into the BuildContext interface and that’s why it’s different for every single widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "However, Elements do not themselves draw on the UI, it is the RenderObject’s task. RenderObject can be likened to a builder, who’s responsible for controlling the sizes, layouts, and painting a piece of the UI.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Widget is the blueprint — holding the config for a piece of the UI.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "RenderObject is the builder — controlling the sizes, layouts, and painting a piece of the UI.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Element is the manager — holding reference of Widget and RenderObject to manage the UI building process.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                WebImage(src = Resources.Images.WIDGET_TREE_RELATIONSHIP_0_FLUTTER,
                    modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                    contentDescription = "Widget tree relationship")

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When we pass a Widget Tree into the runApp function, Flutter will walk through that Tree from the root Widget up. It maps each widget in the widget tree to an element in the element tree. StatelessWidget will create StatelessElement and StatefulWidget will create StatefulElement.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                WebImage(src = Resources.Images.WIDGET_TREE_RELATIONSHIP_1_FLUTTER,
                    modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                    contentDescription = "Widget tree relationship")

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "As I’ve mentioned above, each Element will hold a reference to the Widget. For example, if we were to view the code of the class Element, we can see that there is a property with the type Widget. This widget variable is not final, so the Element class is mutable and the Element object can be updated.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "StatefulElement is a little more special, other than holding the reference of StatefulWidget, it also holds the reference to the State<StatefulWidget> object via a variable called state. It is clear when we view the constructor of StatefulElement:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In short, the relationship between Widget Tree, Element Tree, and State Object is that StatefulElement has the reference of StatefulWidget and State; while StatelessElement has the reference of StatelessWidget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            WebImage(src = Resources.Images.WIDGET_TREE_RELATIONSHIP_2_FLUTTER,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Widget tree relationship")

            SpanText(
                text = "Render Tree",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The render tree represents the visual elements of the application, such as graphics, animation, and text. It is efficiently updated by Flutter’s rendering engine to reflect changes in the widget tree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Interestingly this is what brings UI to the screen it also handles positioning and painting, hit-testing, and accessibility of widgets you create. All Widgets you use contain a RenderObject.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "As I’ve mentioned above, each Element will hold a reference to the Widget. For example, if we were to view the code of the class Element, we can see that there is a property with the type Widget. This widget variable is not final, so the Element class is mutable and the Element object can be updated.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )

                    KotlinCode(
                        code = """
                             class Element {
                                 Element(Widget widget) : _widget = widget;
                                 
                                 Widget? _widget;
                             }
                        """.trimIndent()
                    )

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "StatefulElement is a little more special, other than holding the reference of StatefulWidget, it also holds the reference to the State<StatefulWidget> object via a variable called state. It is clear when we view the constructor of StatefulElement:",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    KotlinCode(
                        code = """
                             class StatefulElement extends ComponentElement {
                               StatefulElement(StatefulWidget widget)
                                   : _state = widget.createState(), // HERE    State<StatefulWidget>? _state; // HERE
                             }
                        """.trimIndent()
                    )

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "In short, the relationship between Widget Tree, Element Tree, and State Object is that StatefulElement has the reference of StatefulWidget and State; while StatelessElement has the reference of StatelessWidget.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            WebImage(src = Resources.Images.WIDGET_TREE_RELATIONSHIP_3_FLUTTER,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Widget tree relationship")


            SpanText(
                text = "Widget Tree",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The widget tree is a hierarchical structure of widgets that represents the user interface of a Flutter application.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Widgets are the basic building blocks of a Flutter UI, and they are organized in a tree-like structure.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Each widget can have child widgets, creating a tree structure where each widget represents a part of the UI.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                        SpanText(
                            text = "Layout and Painting",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                   Ul {
                       Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                           SpanText(
                               text = "Flutter’s rendering engine efficiently handles layout and painting by comparing the previous and current render trees and updating only what has changed. This approach leads to high-performance rendering.",
                               modifier = Modifier
                                   .fontSize(FontSize.Medium))
                       }
                   }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                        SpanText(
                            text = "Widgets Framework",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Flutter provides an extensive set of pre-designed widgets, allowing developers to create complex UIs easily. These widgets are highly customizable and can be combined to create custom UI components.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                        SpanText(
                            text = "Hot Reload",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "One of Flutter’s standout features is its “Hot Reload” capability, which enables developers to make real-time code changes and see the results instantly in the app, greatly speeding up the development process.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                        SpanText(
                            text = "Flutter Engine",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "At the heart of Flutter lies the C/C++ Flutter engine, responsible for interacting with the platform-specific code and rendering. It bridges the gap between Flutter’s Dart code and the underlying platform (iOS, Android, or web).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                        SpanText(
                            text = "Platform Channels",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Flutter allows communication with platform-specific APIs and services through platform channels. This enables developers to access device features and native functionality.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "In summary, Flutter’s architecture is based on a reactive framework, where the UI is rebuilt in response to changes in the widget tree. This approach, coupled with the Dart language and the Flutter engine, makes it a powerful and flexible framework for developing cross-platform applications with high-performance, expressive UIs.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                WebImage(src = Resources.Images.WIDGET_TREE_1_FLUTTER,
                    modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                    contentDescription = "Widget tree")

                WebImage(src = Resources.Images.WIDGET_TREE_2_FLUTTER,
                    modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                    contentDescription = "Widget tree")

                WebImage(src = Resources.Images.WIDGET_TREE_3_FLUTTER,
                    modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                    contentDescription = "Widget tree")

                Ul {
                    Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                        SpanText(
                            text = "PerformLayout and shouldRelayout",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In performLayout, we will get each child by its id, and add layoutChild and positionChild for the same. The layoutChild will give the child a width and a height. The postionChild will set the position of the child based on our calculation of Offset.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "shouldRelayout checks for the changes in maxWidth and maxHeight in our case, and if those do not match with the old then it will perform layout on the children.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "Widget rebuild in a flutter",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Widgets are the building blocks of the UI. They form the widget tree, with each widget having its parent widget and possibly child widgets.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Each widget holds its state, which, when changed, triggers a build method call and, consequently, a rebuild of the widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "However, when Flutter rebuilds the widget, it’s not merely the same widget but a new widget instance.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "he lifecycle of a widget in Flutter involves creation, update, and destruction phases, and it’s during the update phase when the unwanted widget build may occur.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                    SpanText(
                        text = "Each time the Widget is rebuilt, Element will compare the old Widget object whose reference it is holding with the new Widget object: If the old Widget and new Widget have the same Type (for example both of them are CounterWidget), then the element updates its reference to point to the new widget and drops the reference to the old widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                WebImage(src = Resources.Images.WIDGET_REBUILD_FLUTTER,
                    modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                    contentDescription = "Widget rebuild")

            }

            SpanText(
                text = "What is state?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "State refers to the mutable data that determines how a Flutter widget behaves and how it is displayed on the screen.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter is declarative. This means that Flutter builds its user interface to reflect the current state of your app.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "So state can be described as the data needed in order to rebuild the UI at whichever given point in time. It controls the behavior and appearance of widgets. This data can change at any moment, and how it changes will also determine how the UI is rebuilt. Handling these changes efficiently is vital for creating responsive and interactive user interfaces in Flutter.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Types of state",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Ephemeral state",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                  Ul {
                      Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                          SpanText(
                              text = "This is local state.",
                              modifier = Modifier
                                  .fontSize(FontSize.Medium)
                          )
                      }

                      Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                          SpanText(
                              text = "This is the state that affects only one widget and is therefore confined to it.",
                              modifier = Modifier
                                  .fontSize(FontSize.Medium)
                          )
                      }

                      Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                          SpanText(
                              text = "There is no need to use the various complex state management approaches for this local state.",
                              modifier = Modifier
                                  .fontSize(FontSize.Medium)
                          )
                      }

                      Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                          SpanText(
                              text = "A stateful widget and setState can handle this perfectly.",
                              modifier = Modifier
                                  .fontSize(FontSize.Medium)
                          )
                      }

                      Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                          SpanText(
                              text = "An example of ephemeral state is the current page in a PageView.",
                              modifier = Modifier
                                  .fontSize(FontSize.Medium)
                          )
                      }
                  }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Application state",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This is shared state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It represents the overall state of the entire application as it involves data that needs to be shared and accessed across various widgets within the application. Unlike ephemeral state, app state is global and typically stored at a higher level so that different parts of the application can read and modify this shared state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "An example of ephemeral state is authentication status, notifications, inbox items etc.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            WebImage(src = Resources.Images.STATE_TYPE_URL,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "state")

            SpanText(
                text = "SetState()",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The low-level approach for ephemeral widget state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When setState() is called on a State object, all descendent widgets rebuild. Therefore, localize the setState() call to the part of the subtree whose UI actually needs to change. Avoid calling setState() high up in the tree if the change is contained to a small part of the tree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "setState notifies the framework that the internal state of an object has changed in a way that might impact the user interface in this subtree, which causes the framework to schedule a build for this State object.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If without calling setState, the framework might not schedule a build and the user interface for this subtree might not be updated to reflect the new state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is recommended that the setState method only be used to wrap the actual changes to the state, not any computation that might be associated with the change.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Whenever you change the internal state of a State object, make the change in a function that you pass to setState:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                    @protected
                    void setState(
                        VoidCallback
                    )

                    //Widget may no longer be mounted, if dispose() was called after build()
                    if (mounted) {
                      setState(() => _cachedWidget = null);
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The provided callback is immediately called synchronously. It must not return a future (the callback cannot be async), since then it would be unclear when the state was being set.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Calling setState notifies the framework that the internal state of this object has changed in a way that might impact the user interface in this subtree, which causes the framework to schedule a build for this State object.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If you just change the state directly without calling setState, the framework might not schedule a build and the user interface for this subtree might not be updated to reflect the new state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Generally, it is recommended that the setState method only be used to wrap the actual changes to the state, not any computation that might be associated with the change. For example, here a value used by the build function is incremented, and then the change is written to disk, but only the increment is wrapped in the setState.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "That said, it is better practice to cancel whatever work might trigger the setState rather than merely checking for mounted before calling setState, as otherwise CPU cycles will be wasted.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "context.mounted",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "context.mounted to avoid unnecessary refactoring.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When working with asynchronous processes in Flutter, it’s important to avoid rebuilding unnecessary widgets.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This can lead to performance issues and intermittent user experience.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The context.mounted property, introduced in Flutter 3.7, provides a simple and effective way to check if the widget is still installed in the tool tree before performing an update.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This allows you to prevent unnecessary rebuilds if the widget is removed from the tree while the asynchronous process is running.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "markNeedsBuild()",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Marks this layout builder as needing to rebuild.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The layout build rebuilds automatically when layout constraints change. However, we must also rebuild when the widget updates, e.g., after State.setState, or State.didChangeDependencies, even when the layout constraints remain unchanged.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Rebuilding",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dirty elements are rebuilt during the next frame. Precisely how this is done depends on the kind of element. A StatelessElement rebuilds by using its widget’s StatelessWidget.build method. A StatefulElement rebuilds by using its widget’s state’s State.build method. A RenderObjectElement rebuilds by updating its RenderObject.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In many cases, the end result of rebuilding is a single child widget or (for MultiChildRenderObjectElements) a list of children widgets.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "These child widgets are used to update the widget property of the element’s child (or children) elements. The new Widget is considered to correspond to an existing Element if it has the same Type and Key. (In the case of MultiChildRenderObjectElements, some effort is put into tracking widgets even when they change order; see RenderObjectElement.updateChildren).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If there was no corresponding previous child, this results in a new Element being created (using Widget.createElement); that element is then itself built, recursively.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If there was a child previously but the build did not provide a corresponding child to update it, then the old child is discarded (or, in cases involving GlobalKey reparenting, reused elsewhere in the element tree).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The most common case, however, is that there was a corresponding previous child. This is handled by asking the child Element to update itself using the new child Widget. In the case of StatefulElements, this is what triggers State.didUpdateWidget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Performance Benefits",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Having three separate trees (widget, element, render object) provides performance benefits.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When changes occur in the widget tree, Flutter utilizes the element tree to compare the new widget tree with the existing render objects.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If the type of a widget remains the same, Flutter doesn’t recreate the expensive render object but updates its mutable configuration.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Widgets, being lightweight and cheap to instantiate, are used to describe the app’s current state. Expensive render objects are not recreated every time but are reused whenever possible.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "What do you understand from ‘State’? What is the use of the setState() method?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "State refers to the information that you can read synchronously when a widget is built and it might change during the lifetime of the widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The widget implementor should ensure that the ‘State’ is promptly notified of a change of state using State.setState method. The ‘setState’ method is used to notify the changed state of an internal object.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "SetState has its own limitations",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Share More state across components: Internal state management becomes troublesome when you need to share more states across components.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Distant leaf components need access to states: Intermediary components don’t need to know become a problem as data gets shared to all pass-through.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "setState calls stateSet",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The other two locations in the buildIn() function where the interface can change are enclosed in the stateSet() function.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BuildContext parameter, context, is not needed in this particular WidgetBuilder function. It is a WidgetBuilder type that’s passed into the stateSet() function.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The idea is you can then have a number of these stateSet() functions here and there in your interface each with one or two widgets that need to be updated all the time.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You want to leave the rest of the interface alone. Conceivably, dozens of widgets can make up your interface, and it would be ‘expensive’ to update the whole interface just as often. The second screenshot below reveals the stateSet() function.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "What tools and techniques do you use for profiling and monitoring Flutter applications?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tools and techniques include Flutter DevTools for performance profiling, the flutter analyze command for static code analysis, and monitoring solutions like Firebase Crashlytics for error reporting and analytics. Profiling helps identify performance bottlenecks and optimize the application.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "How do you identify and fix performance bottlenecks in a Flutter application?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Performance bottlenecks are identified using the Flutter DevTools, which provide profiling and debugging capabilities. I look for issues like jank (frame drops), excessive rebuilds, and inefficient UI rendering. Fixes might include optimizing widget trees, using const constructors, and avoiding unnecessary computations in the build method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

